import React, { useState } from "react";
import axios from "axios";
import "../../Style/TableStyle.scss";
import "../../Style/__searchbar.scss";
import "../../Style/__button.scss";
import "./OtherAccountsPage.scss";
import { deleteAlert, errorAlert, handleSuccess } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { AiFillCopy } from "react-icons/ai";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DataGridServerSide from "../../Components/DataGridServerSide";
import CrudPageHeader from "../../Components/CrudPageHeader";
import useAccountsGridData from "../../hooks/useAccountsGridData";
import OtherAccountsModal from "./OtherAccountsModal";
import OtherAccountsViewModal from "./OtherAccountsViewModal";

export default function OtherAccountsPage() {
  const headers = authHeader();
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [viewAccount, setViewAccount] = useState(null);

  const getApiErrorMessage = (error, fallbackMessage) => {
    if (error?.response?.data?.errorMessage) {
      return `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`;
    }
    if (
      typeof error?.response?.data === "string" &&
      error.response.data.trim() !== ""
    ) {
      return error.response.data;
    }
    if (error?.message) {
      return `Gabim: ${error.message}`;
    }
    return fallbackMessage;
  };

  const {
    loading,
    data,
    rowCount,
    paginationModel,
    setPaginationModel,
    sortModel,
    setSortModel,
    filterModel,
    setFilterModel,
    quickFilter,
    setQuickFilter,
    fetchData,
  } = useAccountsGridData({
    headers,
    endpoint: "Accounts/getAccountsFiltered",
    onError: (error) =>
      errorAlert(
        getApiErrorMessage(
          error,
          "Gabim i panjohur në marrjen e llogarive të tjera.",
        ),
      ),
  });

  const handleEdit = async (item) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + `Accounts/getAccountForEdit/${item.AccountID}`,
        { headers },
      );
      setSelectedAccount(response.data);
      setShowEditModal(true);
    } catch (error) {
      errorAlert(
        getApiErrorMessage(
          error,
          "Gabim në marrjen e të dhënave të llogarisë për editim.",
        ),
      );
    }
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedAccount(null);
  };

  const handleView = async (item) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + `Accounts/getAccountForEdit/${item.AccountID}`,
        { headers },
      );
      setViewAccount(response.data);
      setShowViewModal(true);
    } catch (error) {
      errorAlert(
        getApiErrorMessage(
          error,
          "Gabim në marrjen e të dhënave të llogarisë për shikim.",
        ),
      );
    }
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setViewAccount(null);
  };

  const handleDelete = async (deleteItemId) => {
    try {
      const response = await axios.delete(
        ApiLink.API_URL + "Accounts/assets" + `/${deleteItemId}`,
        { headers },
      );

      const result = response.data;
      if (result.success) {
        handleSuccess("Llogaria është fshirë me sukses");
        fetchData();
      } else {
        deleteAlert(
          "Llogaria nuk mund të fshihet sepse është përdorur në transaksione",
        );
      }
    } catch (error) {
      deleteAlert("Ka ndodhur një gabim gjatë fshirjes së llogaris.");
    }
  };

  const accountGridHeader = [
    {
      field: "id",
      headerName: "#",
      width: 60,
      headerClassName: "super-app-theme--header",
      sortable: false,
      filterable: false,
      groupable: false,
      aggregable: false,
    },
    {
      field: "AccountName",
      headerName: "Emri i Llogarisë",
      flex: 2.6,
      minWidth: 320,
      editable: false,
      headerClassName: "super-app-theme--header",
      groupable: false,
      aggregable: false,
    },
    {
      field: "IsActive",
      headerName: "Aktiv",
      width: 90,
      headerClassName: "super-app-theme--header",
      renderCell: (params) =>
        params.value ? (
          <CheckCircleOutlineIcon style={{ color: "green" }} />
        ) : (
          ""
        ),
    },
  ];

  const rows = data.map((item, index) => ({
    id: paginationModel.page * paginationModel.pageSize + index + 1,
    AccountName: item.AccountName,
    IsActive: Boolean(item.IsActive),
    deleteItemId: item.AccountID,
    rowInfo: item,
  }));

  return (
    <div className="Crud__Container OAP__page">
      <OtherAccountsModal
        show={showEditModal}
        onHide={handleCloseEditModal}
        mode="edit"
        initialData={selectedAccount}
        fetchData={fetchData}
      />

      <OtherAccountsViewModal
        show={showViewModal}
        onHide={handleCloseViewModal}
        accountData={viewAccount}
      />

      <CrudPageHeader
        icon={AiFillCopy}
        title="Lista e Llogarive Tjera"
        description="Forma e Llogarive tjera: Menaxhoni, shtoni, editoni dhe fshini llogari tjera."
        tutorialUrl="https://www.youtube.com/@Accountree"
        tutorialLabel="Shiko Tutorialin"
        action={<OtherAccountsModal fetchData={fetchData} type="text" />}
        className="OAP__header"
      />

      <DataGridServerSide
        columns={accountGridHeader}
        rows={rows}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handleShowPrint={handleView}
        showPayment={false}
        height={500}
        rowCount={rowCount}
        loading={loading}
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        sortModel={sortModel}
        setSortModel={setSortModel}
        filterModel={filterModel}
        setFilterModel={setFilterModel}
        quickFilter={quickFilter}
        setQuickFilter={setQuickFilter}
        showDetailsStatus={true}
      />
    </div>
  );
}